// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"pn-z","badgeLink":"qn-z","category":"rn-z"};